/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import {
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TextField,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { strings } from 'i18n/Strings';
import { dateFormater, UnitFormater } from 'utils/GeneralUtil';
import { CurrencyFormater } from 'components/helpers/commonFunctions/CurrencyFormater';

export interface DataType {
  amount: number;
  contributionFileId: number;
  contributionFileInfo: object | null;
  pensionPlan: number;
  plan: number;
  transactionDate: Date;
  transactionId: number;
  transactionStatus: string;
  transactionType: string;
  userFunds: UserFundsType[] | null;
  userSalesUnits: UserFundsType[] | null;
  userId: number;
}

export interface UserFundsType {
  fundId: number;
  fundInfo: {
    fundId: number;
    name: string;
    contractId: number;
    fund_type: string;
    symbol: number;
    shortDescription: string;
  };
  fundSplitDate: Date;
  orderId: number;
  orderInfo: {
    mmOrderId: number;
    ibOrderId: number;
    fundId: number;
    mmTransactionId: number;
    orderStatus: string;
    totalUnits: string;
    orderDate: Date;
    tradePrice: number;
  };
  pensionPlanId: number;
  pensionPlanInfo: {
    planId: number;
    name: string;
  };
  planId: number;
  planInfo: {
    planId: number;
    planName: string;
  };
  splitAmount: string;
  unitAmount: string;
  transactionId: number;
  userFundId: number;
  userId: number;
}

export interface OrderStatusSummaryProps {
  data: DataType;
}

const OrderStatusSummary = (props: OrderStatusSummaryProps): JSX.Element => {
  const combinedData = [
    ...(props?.data?.userFunds || []),
    ...(props?.data?.userSalesUnits || []),
  ];

  return (
    <Grid
      item
      xs={12}
      sm={12}
      md={12}
      sx={{
        marginBlock: 2,
        width: '800px',
        fontFamily: 'Inter !important',
      }}
    >
      {combinedData.length > 0 &&
        combinedData.map((val, index) => (
          <Accordion key={index}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`panel${index}-content`}
              id={`panel${index}-header`}
            >
              <strong>{`${strings.displayText.orderStatus} ${
                index + 1
              }`}</strong>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                display: 'flex',
                flexDirection: 'column',
                padding: '20px',
                lineHeight: 2,
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextField
                    margin="normal"
                    fullWidth
                    label={strings.displayText.mmOrderId}
                    value={val?.orderInfo?.mmOrderId}
                    InputProps={{ readOnly: true }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    margin="normal"
                    fullWidth
                    label={strings.displayText.ibOrderId}
                    value={val?.orderInfo?.ibOrderId}
                    InputProps={{ readOnly: true }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    margin="normal"
                    fullWidth
                    label={strings.displayText.orderStatus}
                    value={val?.orderInfo?.orderStatus}
                    InputProps={{ readOnly: true }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    margin="normal"
                    fullWidth
                    label={strings.displayText.orderDate}
                    value={dateFormater(val?.orderInfo?.orderDate)}
                    InputProps={{ readOnly: true }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    margin="normal"
                    fullWidth
                    label={strings.displayText.totalUnits}
                    value={UnitFormater(Number(val?.orderInfo?.totalUnits))}
                    InputProps={{ readOnly: true }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    margin="normal"
                    fullWidth
                    label={strings.displayText.totalContribution}
                    value={CurrencyFormater(
                      Number(val?.splitAmount || val?.unitAmount),
                    )}
                    InputProps={{ readOnly: true }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    margin="normal"
                    fullWidth
                    label={strings.displayText.fundName}
                    value={val?.fundInfo?.shortDescription}
                    InputProps={{ readOnly: true }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    margin="normal"
                    fullWidth
                    label={strings.displayText.contractId}
                    value={val?.fundInfo?.contractId}
                    InputProps={{ readOnly: true }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    margin="normal"
                    fullWidth
                    label={strings.displayText.symbol}
                    value={val?.fundInfo?.symbol}
                    InputProps={{ readOnly: true }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    margin="normal"
                    fullWidth
                    label={strings.displayText.fundType}
                    value={val?.fundInfo?.fund_type}
                    InputProps={{ readOnly: true }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    margin="normal"
                    fullWidth
                    label={strings.displayText.tradePrice}
                    value={val?.orderInfo?.tradePrice}
                    InputProps={{ readOnly: true }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    margin="normal"
                    fullWidth
                    label={strings.displayText.transactionType}
                    value={props?.data.transactionType}
                    InputProps={{ readOnly: true }}
                  />
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        ))}
    </Grid>
  );
};

export default OrderStatusSummary;
